export const BATTLEFEED_REQUESTED = 'BATTLEFEED_REQUESTED'
export const BATTLEFEED_RESOLVED = 'BATTLEFEED_RESOLVED'
export const BATTLEFEED_ERROR = 'BATTLEFEED_ERROR'
